import React from 'react';
import { gql } from 'graphql-tag';
import { Show } from 'react-admin';
import RateSettingsShow from '../shared/rate-settings-show/RateSettingsShow';

const MarketLocationTypeRateSettingShow = () => {
  return (
    <Show>
      <RateSettingsShow />
    </Show>
  );
};

MarketLocationTypeRateSettingShow.query = gql`
  query marketLocationTypeRateSetting($id: Int!) {
    marketLocationTypeRateSetting(id: $id, include_parents: true) {
      id
      active
      created_at
      market_id
      location_type_id
      location_type {
        id
        label
      }
      market {
        id
        display_name
      }
      settings
      market_location_type_rate_setting
      updated_at
    }
  }
`;

export default MarketLocationTypeRateSettingShow;
